import { useState } from 'react'

import { auditAbortiveExplainApi } from '@eastcoal/api/trade/abortiveExplain/auditAbortiveExplain'

import { ActionButton } from '@eastcoal/common/components/Button/ActionButton'
import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { pick } from '@eastcoal/common/utils/object'

import { FormMode } from '@eastcoal/formily/components/CrudForm/enums/FormMode'
import { useCrudFormStore } from '@eastcoal/formily/components/CrudForm/Store/hooks/useStore'
import { useCrudModalFormStore } from '@eastcoal/formily/components/CrudModalForm/Store/hooks/useStore'

import { AbortiveExplainStatus } from '../../../../../enums/AbortiveExplainStatus'
import { useAuctionListStore } from '../../../../../Store/hooks/useStore'

import { AuditButtonProps } from './interface'

export const AuditButton = ({
  auditStatus,
  icon,
  type = 'primary',
  children = '审核'
}: AuditButtonProps) => {
  const [loading, setLoading] = useState(false)
  const { message } = useFeedback()
  const { toggleModalOpen } = useCrudModalFormStore(state =>
    pick(state, ['toggleModalOpen'])
  )
  const { mode, detailData, form } = useCrudFormStore(state =>
    pick(state, ['mode', 'detailData', 'form'])
  )
  const { tableRef } = useAuctionListStore(state => pick(state, ['tableRef']))

  const handleAudit = async () => {
    try {
      setLoading(true)
      await form.submit(async values => {
        await auditAbortiveExplainApi({
          ...values,
          status: auditStatus
        })
      })
      message.success('审核成功！')
      toggleModalOpen()
      tableRef.current?.reload()
    } catch (error) {
      console.error('审核失败:', error)
      message.error('审核失败！')
    } finally {
      setLoading(false)
    }
  }

  return (
    detailData.status === AbortiveExplainStatus.WAIT_AUDIT &&
    mode === FormMode.UPDATE && (
      <ActionButton
        ghost={auditStatus !== AbortiveExplainStatus.AUDIT_SUCCESS}
        icon={icon}
        loading={loading}
        type={type}
        onClick={handleAudit}
      >
        {children}
      </ActionButton>
    )
  )
}
